import { APIS } from "../../components/constants/app.constant";
import { getResource, postResource } from "../axiosService";

export function getStateTaxes(){
    const apiUrl = APIS.STATE_TAXES;
    return getResource(apiUrl);
}
export function postStateTaxes(data: any){
    const apiUrl = APIS.STATE_TAXES;
    return postResource(apiUrl, data);
}